'use client';

/**
 * ServiceWorker 등록 컴포넌트
 * layout.tsx에 삽입하여 앱 시작 시 SW 자동 등록
 * [2026-02-23] 최초 작성
 */

import { useEffect } from 'react';

export default function ServiceWorkerRegistrar() {
    useEffect(() => {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker
                .register('/sw.js')
                .catch((err) => console.warn('[SW] 등록 실패:', err));
        }
    }, []);

    return null;
}
